export default __webpack_public_path__ + "static/media/answer_question.c42d63cb.svg";